import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=31092d2a&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=31092d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31092d2a",
  null
  
)

export default component.exports